// extracted by mini-css-extract-plugin
export default {"no_streak":"Streak_no_streak__WSNBK","streak":"Streak_streak__uZl22","streak_text":"Streak_streak_text__xxUdq"};